// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"i2w3Q":[function(require,module,exports) {
require("41e07e52f993fb20").register(require("3e10f4e7199f8915").getBundleURL('an8IN'), JSON.parse("[\"an8IN\",\"iframe.12d9acd0.js\",\"f1Tnm\",\"Illustrations.e7d958f3.js\",\"jTr0o\",\"Illustrations.d66ac3bf.js\",\"i9sxa\",\"Illustrations.e447486c.js\",\"1Cpgx\",\"Illustrations.17cdef70.css\",\"ffuTQ\",\"Illustrations.e469d1bb.js\",\"hKAF0\",\"Illustrations.80046a18.js\",\"4TeH0\",\"Illustrations.21082a54.js\",\"1psdr\",\"Illustrations.743f0fdc.js\",\"lvRe0\",\"Illustrations.7244b47d.js\",\"cO7LD\",\"Illustrations.511d19b8.js\",\"kdhGh\",\"Illustrations.8cb932c6.css\",\"8SHUI\",\"Illustrations.3ce8c54a.js\",\"5wQ47\",\"Illustrations.471e8666.js\",\"cplIG\",\"Illustrations.0e83b700.css\",\"gYsPi\",\"Illustrations.91da0d26.js\",\"eqHDu\",\"Illustrations.802c6ca8.js\",\"gaxVb\",\"Illustrations.44d64c30.css\",\"5okOW\",\"Intro.704cf279.js\",\"cqoRZ\",\"wallpaper_collaborative_S2_desktop.1ae295a9.webp\",\"f9pjT\",\"Intro.05ab812a.css\",\"4gFmB\",\"Migrating.b7c83e4e.js\",\"jzRCs\",\"Migrating.00ca9c87.css\",\"6496W\",\"Release Notes.8b9c0903.js\",\"lL9aj\",\"Release Notes.bc08c937.css\",\"kQUbE\",\"Style Macro.ab6ac498.js\",\"jbrLv\",\"Style Macro.6cd12fac.css\",\"kNv8g\",\"Workflow Icons.bdf9840c.js\",\"81ILZ\",\"Workflow Icons.b3fe70da.css\",\"lIvSw\",\"ActionButton.stories.58b70cb2.js\",\"e0dxz\",\"ActionButton.stories.ba2633df.css\",\"7W0ng\",\"ActionMenu.stories.abaa026f.js\",\"gEddj\",\"ActionMenu.stories.9f6ff5b9.css\",\"8DN7u\",\"AlertDialog.stories.bd27849b.js\",\"e3S19\",\"AlertDialog.stories.5cfce6ea.css\",\"8OvTO\",\"Avatar.stories.09dfb709.js\",\"9w1MS\",\"Avatar.stories.3dd31f6c.css\",\"aF3o8\",\"AvatarGroup.stories.4f26feac.js\",\"7jTuc\",\"AvatarGroup.stories.e695be5c.css\",\"7SYwK\",\"Badge.stories.464bbb64.js\",\"8b3lR\",\"Badge.stories.7c8e7679.css\",\"9pGzB\",\"Breadcrumbs.stories.4c37fd2d.js\",\"CEzO9\",\"Breadcrumbs.stories.5ff91b82.css\",\"lbjDW\",\"Button.stories.49a992bc.js\",\"ybfZk\",\"Button.stories.4dd3b0ce.css\",\"3wOzp\",\"ButtonGroup.stories.00ae48c1.js\",\"2iaZK\",\"ButtonGroup.stories.1bc9cef2.css\",\"lCeoA\",\"Calendar.stories.bd05725a.js\",\"joyfx\",\"Card.stories.3ea07659.js\",\"3UHtI\",\"preview.fa2965aa.png\",\"aDnjA\",\"placeholder.f0db36ef.png\",\"ev4Sg\",\"Card.stories.7359821d.css\",\"14JP1\",\"CardView.stories.274d8ba8.js\",\"1CvjW\",\"CardView.stories.81bf79c7.css\",\"6dgN3\",\"Checkbox.stories.5e28b9b2.js\",\"iOeV9\",\"Checkbox.stories.7dff0b20.css\",\"39QzS\",\"CheckboxGroup.stories.416947f3.js\",\"8Wl42\",\"CheckboxGroup.stories.9b1b1f68.css\",\"kQwFH\",\"ColorArea.stories.58086d8d.js\",\"4g45O\",\"ColorArea.stories.45eb775f.css\",\"254zj\",\"ColorField.stories.51a5fe34.js\",\"eSFMR\",\"ColorField.stories.b8af082a.css\",\"3M6cl\",\"ColorSlider.stories.4522db37.js\",\"hVfKX\",\"ColorSlider.stories.24cdf432.css\",\"flKlP\",\"ColorSwatch.stories.09cb5379.js\",\"bPUkJ\",\"ColorSwatch.stories.b6e07fae.css\",\"2EMU3\",\"ColorSwatchPicker.stories.ad2c7b17.js\",\"7Cd7X\",\"ColorSwatchPicker.stories.026e9e47.css\",\"kbOb5\",\"ColorWheel.stories.fdaf5d91.js\",\"lmbOs\",\"ColorWheel.stories.6021f39d.css\",\"hyus8\",\"ComboBox.stories.4d39b9e0.js\",\"2b4GJ\",\"ComboBox.stories.8fb3bf6a.css\",\"19rPp\",\"ContextualHelp.stories.574c5c14.js\",\"fEtYb\",\"ContextualHelp.stories.72342432.css\",\"g9mfJ\",\"DateField.stories.9ccbdbcf.js\",\"9TC9a\",\"DatePicker.stories.2692df93.js\",\"c1u3r\",\"DateRangePicker.stories.9f8ea47d.js\",\"2Y7jU\",\"Dialog.stories.8939415b.js\",\"04QgO\",\"Dialog.stories.8c4603bd.css\",\"f3x1L\",\"Divider.stories.96596b87.js\",\"cHoHM\",\"Divider.stories.81f5029c.css\",\"c8g6f\",\"DropZone.stories.04171d92.js\",\"gjxoF\",\"DropZone.stories.263672dc.css\",\"8joFg\",\"Form.stories.da68f44b.js\",\"91lA1\",\"Form.stories.78b09d66.css\",\"eOYvY\",\"Icon.stories.bac0f5a6.js\",\"i2sdy\",\"Icon.stories.27c6a4f1.css\",\"f1cAi\",\"IllustratedMessage.stories.41489428.js\",\"fzk5Z\",\"IllustratedMessage.stories.c173942a.css\",\"470uv\",\"InlineAlert.stories.541a05fd.js\",\"k85GR\",\"InlineAlert.stories.bd96d887.css\",\"krItI\",\"Link.stories.6d8797c0.js\",\"foFhL\",\"Link.stories.3f756627.css\",\"iszox\",\"LinkButton.stories.ee895e6f.js\",\"hoows\",\"LinkButton.stories.403cfb4f.css\",\"auQgk\",\"ListBox.stories.c3a830a8.js\",\"opEBS\",\"Menu.stories.1ef82f05.js\",\"byKZG\",\"normal.ded32008.png\",\"dVelD\",\"multiply.9c18c7f4.png\",\"64Riu\",\"screen.88c89678.png\",\"hovY1\",\"Menu.stories.28f23f37.css\",\"5QHY3\",\"Meter.stories.cce13f80.js\",\"43VPV\",\"Meter.stories.425ab31c.css\",\"bj5mg\",\"NumberField.stories.5fdf563b.js\",\"8C5BC\",\"NumberField.stories.7765379d.css\",\"34yTe\",\"Picker.stories.6d5bf4cb.js\",\"lqC7a\",\"Picker.stories.4af89b39.css\",\"jZCu7\",\"ProgressBar.stories.68f9bcc6.js\",\"6FY7w\",\"ProgressBar.stories.3971539d.css\",\"hsl3m\",\"ProgressCircle.stories.e258b896.js\",\"1Emjz\",\"ProgressCircle.stories.34896966.css\",\"dNhDe\",\"RadioGroup.stories.1f368ef6.js\",\"fnNC9\",\"RadioGroup.stories.7207b873.css\",\"i8ot1\",\"RangeCalendar.stories.cee6d4dd.js\",\"iv5R5\",\"RangeSlider.stories.4e50bb59.js\",\"kBX5E\",\"RangeSlider.stories.d516c84d.css\",\"kNYyu\",\"SearchField.stories.190903d7.js\",\"69Dht\",\"SearchField.stories.ad2023b2.css\",\"jT6jv\",\"Slider.stories.a5be1bec.js\",\"4u2SK\",\"Slider.stories.8c7cbe72.css\",\"KRPIr\",\"StatusLight.stories.079c6afc.js\",\"7cmWU\",\"StatusLight.stories.f06ce14e.css\",\"bGTCx\",\"StyleMacro.stories.6fbfb3f5.js\",\"87XRj\",\"StyleMacro.stories.055ae20f.css\",\"f337F\",\"Switch.stories.c38df539.js\",\"bBZnP\",\"Switch.stories.458eb1d6.css\",\"3JKrI\",\"Table.stories.ba6a7e5d.js\",\"aIFy0\",\"Table.stories.ea450ffe.css\",\"9HuG6\",\"Tabs.stories.f82e7b6b.js\",\"kemro\",\"Tabs.stories.9cadaa40.css\",\"1CelO\",\"TagGroup.stories.ecb40bcc.js\",\"jludG\",\"TagGroup.stories.c1a1540a.css\",\"33Cdk\",\"TextField.stories.396c3e52.js\",\"6rY6M\",\"TextField.stories.7ffdb648.css\",\"d4gX6\",\"TimeField.stories.2dc7b99d.js\",\"ld75Q\",\"ToggleButton.stories.38a2f7ca.js\",\"h27g6\",\"ToggleButton.stories.5241890b.css\",\"4fZJn\",\"Toolbar.stories.8c2ed49d.js\",\"RC0YE\",\"Tooltip.stories.01a8943f.js\",\"bg9Ne\",\"Tooltip.stories.c4a19789.css\",\"buzaY\",\"entry-preview.48ba04a4.js\",\"jnBOE\",\"entry-preview-docs.e7ebf76b.js\",\"eECph\",\"entry-preview-docs.eee0c9ee.js\",\"eB9rs\",\"preview.04c5bd4e.js\",\"2xPAz\",\"preview.2a4442a8.js\",\"fqdv7\",\"react.96f0c63d.js\",\"h35RA\",\"preview.39bb16bc.js\",\"4U9GS\",\"Color-6VNJS4EI.f0a30a87.js\",\"4wgl6\",\"syntaxhighlighter-B5GMVT5T.9fe71328.js\",\"lYfBy\",\"formatter-SWP5E3XI.67c02861.js\",\"bIqQw\",\"WithTooltip-V3YHNWJZ.e839b76b.js\",\"aXv01\",\"preview.005ea5af.js\",\"dfUYg\",\"preview.582f9f5d.js\",\"hSeK8\",\"preview.52841ff9.js\",\"9S0xC\",\"preview.5db8025c.js\",\"5LHKr\",\"preview.6dbe9463.js\",\"8rzkN\",\"preview.30935d77.js\",\"2IacX\",\"preview.f5a8466a.js\",\"cwmtU\",\"logo.2bd7c023.svg\",\"6sJbD\",\"logo-dark.aa58a0ab.svg\",\"cuJ35\",\"preview.71d54830.css\"]"));

},{"41e07e52f993fb20":"kK08P","3e10f4e7199f8915":"kMf2L"}],"kK08P":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"kMf2L":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
function getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}]},["i2w3Q"], null, "parcelRequire94c2")

//# sourceMappingURL=iframe.runtime.9f1cc123.js.map
